import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '../../util/icons/components/CloseIcon';
import PropTypes from 'prop-types';
import './modal.scss';

class Modal extends Component {
  constructor (props) {
    super(props);
    this.closeRef = React.createRef();
  }
  componentDidMount () {
    if (!this.closeRef || this.closeRef.current === null) return;
    this.closeRef.current.scrollIntoView({ behavior: 'smooth' });
  }
  getStyle () {
    return this.props.pos ? {
      marginTop: (this.props.pos + 44) + 'px'
    } : {};
  }
  handleCloseClicked (event) {
    event.preventDefault();
    this.props.close();
  }
  render () {
    const contentClass = this.props.contentClass
      ? this.props.contentClass + ' content' : 'content';
    return createPortal(
      <div id='modal'>
        <article data-cy={ this.props.contentTestId }
          className={ contentClass }
          style={ this.getStyle() }
          ref={this.modalRef}>
          <div
            className="close-wrapper"
            ref={this.closeRef}
            onClick={ this.handleCloseClicked.bind(this) }>
            <CloseIcon testId="modal-close-icon"/>
          </div>
          { this.props.children }
        </article>
      </div>, document.getElementById('app')
    );
  }
}

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  close: PropTypes.func.isRequired,
  pos: PropTypes.number,
  contentClass: PropTypes.string,
  contentTestId: PropTypes.string
};

export default Modal;
